function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.286 3.982a.3.3 0 00.428 0L9.411.218a.3.3 0 01.428 0l.954.972a.3.3 0 010 .42L5.715 6.782a.3.3 0 01-.428 0L.206 1.61a.3.3 0 010-.42l.955-.972a.3.3 0 01.428 0l3.697 3.764z"
});
function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgSelectArrow;